import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";

export default function NewsTicker() {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    api.get("/articles?limit=10")
      .then((r) => setArticles((r.data || []).filter((a) => !a.is_premium).slice(0, 8)))
      .catch(() => {});
  }, []);

  if (articles.length === 0) return null;
  const items = [...articles, ...articles];

  return (
    <div
      className="overflow-hidden relative"
      style={{
        background: "var(--gai-black)",
        borderBottom: "1px solid var(--gai-grey-200)",
      }}
      data-testid="news-ticker"
    >
      <div className="flex items-stretch">
        <div
          className="shrink-0 flex items-center gap-2 px-5 py-3 font-bold text-[0.62rem] tracking-[0.28em] uppercase"
          style={{ background: "var(--gai-red)", color: "var(--gai-white)" }}
        >
          <span className="w-2 h-2 rounded-full animate-pulse" style={{ background: "var(--gai-white)" }} />
          À la une
        </div>
        <div className="flex-1 overflow-hidden relative">
          <div className="gai-ticker-track flex gap-0 whitespace-nowrap py-3">
            {items.map((a, i) => (
              <Link
                key={`${a.id}-${i}`}
                to={`/articles/${a.slug}`}
                className="px-6 inline-flex items-center gap-3 transition-colors"
                style={{ color: "rgba(255,255,255,0.85)" }}
                data-testid={i < articles.length ? `ticker-item-${i}` : null}
              >
                <span className="w-1 h-1 rounded-full" style={{ background: "var(--gai-red)" }} />
                <span className="text-sm hover:text-white">{a.title?.fr || a.title?.en}</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
